import { get } from '@aiptyg/api-client';
import type { SystemLogFilter, SystemLogItem, SystemLogListResponse } from '../types/system-logs.types';

function buildQuery(filter: SystemLogFilter, page: number, pageSize: number): string {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('page_size', String(pageSize));
  Object.entries(filter).forEach(([key, value]) => {
    const trimmed = String(value ?? '').trim();
    if (trimmed) params.set(key, trimmed);
  });
  return params.toString();
}

export function listSystemLogs(
  filter: SystemLogFilter,
  page: number,
  pageSize: number,
): Promise<SystemLogListResponse> {
  return get<SystemLogListResponse>(`/v1/admin/system-logs?${buildQuery(filter, page, pageSize)}`);
}

export function getSystemLog(id: number): Promise<SystemLogItem> {
  return get<SystemLogItem>(`/v1/admin/system-logs/${id}`);
}

export function getClientDiagnostics(uploadId: string): Promise<unknown> {
  return get<unknown>(`/v1/admin/system-logs/diagnostics/${encodeURIComponent(uploadId)}/download`);
}
